module.exports = "<span class=\"fl-right crs-pointer auth-language-directive\" ng-click=\"ChangeLanguageCtrl.openModal('change-lang')\" connectqa-login=\"change-language\">\n    <span class=\"fl-left icon language-switcher icon-grey-4 icon-xs\"></span>\n    <span class=\"text-grey-4 mlr5\">{{currentLanguage}}</span>\n</span>\n"


//////////////////
// WEBPACK FOOTER
// ./scripts/directives/dashboard/auth/change-language/change-language.html
// module id = jdje
// module chunks = 0